module.exports = __webpack_public_path__ + "static/media/filled-thumbs-down.092e72e5.svg";